import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=33d0d19e&scoped=true&"
import script from "./CartItem.vue?vue&type=script&lang=ts&"
export * from "./CartItem.vue?vue&type=script&lang=ts&"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=33d0d19e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0d19e",
  null
  
)

export default component.exports